// frontend/src/site/templates/TemplateCorretorLovable/pages/Index.jsx
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import PropertiesSection from '../components/PropertiesSection';
import ServicesSection from '../components/ServicesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const Index = ({
  siteConfig,
  properties = [],
  slug,
  handle,
  conteudo,
  loading = false,
}) => {
  return (
    <div className="min-h-screen bg-zinc-50">
      <Header siteConfig={siteConfig} slug={slug} />

      <main>
        <HeroSection siteConfig={siteConfig} slug={slug} />

        <AboutSection siteConfig={siteConfig} slug={slug} />

        {/* importante: handle para basePath + conteudo para respeitar ids do builder */}
        <PropertiesSection
          siteConfig={siteConfig}
          properties={properties}
          slug={slug}
          handle={handle}
          conteudo={conteudo}
          loading={loading}
        />

        <ServicesSection siteConfig={siteConfig} slug={slug} />
        <TestimonialsSection siteConfig={siteConfig} slug={slug} />
        <CTASection siteConfig={siteConfig} slug={slug} />
      </main>

      <Footer siteConfig={siteConfig} slug={slug} />
    </div>
  );
};

export default Index;
